<div class="grid" data-test-id="aufgabe-wiedervorlage-root">
	<div class="form-date-picker">
		<mat-form-field appearance="outline" [formGroup]="formGroup">
			<mat-label>Datum Wiedervorlage</mat-label>
			<input
				matInput
				[matDatepicker]="picker"
				[formControl]="bodyControls.wiedervorlageDatum"
				data-test-id="wiedervorlage-datum" />
			<mat-datepicker-toggle matSuffix [for]="picker" />
			<mat-datepicker #picker />
			@if (bodyControls.wiedervorlageDatum.errors) {
				<mat-error data-test-id="wiedervorlage-datum-error-pattern-date">
					Datum Wiedervorlage muss ein Datum sein
				</mat-error>
			}
		</mat-form-field>
	</div>
	<schir-int-client-notiz-in-aufgabe-editor
		class="row note"
		[aufgabenTyp]="aufgabenTyp()"
		data-test-id="aufgabe-notiz" />
</div>
